import loadergiff from '../../common/assets/gif/loader.gif'
import   './LoaderComponent.scss'
const LoaderComponent =()=>{
    return(
        <div className="MenuPageDesktop-View">
            <img src={loadergiff} alt="" className='Loaders-img' />
        </div>
    )
}

export default LoaderComponent